import { render } from "./SignUpPage.vue?vue&type=template&id=1c56032c&ts=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__